import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MethodsHelper } from '@app/helpers/methods.helper';

@Component({
    selector: 'app-input-number-format',
    templateUrl: './input-number-format.component.html',
    styleUrls: ['./input-number-format.component.css'],
    standalone: false
})
export class InputNumberFormatComponent implements OnChanges {

  @Input() value: number;
  @Input() maxLength: number;
  @Input() allowNegative: boolean;
  @Input() readonly: boolean;
  @Input() haveClearButton: boolean;
  @Input() layoutClassName: string;
  @Input() className: string;
  @Input() placeholder: string;
  @Output() onCommitChangeValue = new EventEmitter<number>();

  displayValue: string;

  constructor(
  ) { }

  ngOnChanges() {
    this.displayValue = MethodsHelper.numberWithCommasAllowNull(this.value);
    if (!MethodsHelper.haveValue(this.readonly)) {
      this.readonly = false;
    }
  }

  numberOnly(event): boolean {
    if (MethodsHelper.haveValue(this.maxLength) && MethodsHelper.haveValue(this.displayValue) && this.displayValue.length >= this.maxLength) {
      return false;
    }
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode == 46 || (this.allowNegative && charCode == 45) || (charCode >= 48 && charCode <= 57));
  }

  checkIfNegative(value) {
    if (this.allowNegative && MethodsHelper.haveValue(value) && value.charAt(0) == '-') {
      return true;
    }
    return false;
  }

  onAmountFieldFocused(event) {
    this.displayValue = MethodsHelper.numberWithoutCommasAllowNullInString(this.displayValue);
  }

  onAmountFieldFocusedout(event) {
    let isNavigate = this.checkIfNegative(this.displayValue);
    if (MethodsHelper.haveValue(this.displayValue)) {
      this.displayValue = this.displayValue.replace(/-/g, '');
    }
    let value = MethodsHelper.numberWithoutCommasAllowNull(this.displayValue);
    if (MethodsHelper.haveValue(value)) {
      this.displayValue = (isNavigate ? '-' : '') + MethodsHelper.amountInputFieldFocusOut(value.toString());
    } else {
      this.displayValue = "";
    }
    let updatedValue = MethodsHelper.numberWithoutCommasAllowNull(this.displayValue);
    this.onCommitChangeValue.emit(updatedValue);
  }
  
  showClearButton(){
    return this.haveClearButton && MethodsHelper.haveValue(this.value);
  }

  onClear(){
    this.value = undefined;
    this.onCommitChangeValue.emit(this.value);
  }
}
